import styled from 'styled-components';

const MainWrapper = styled.div``;

export default MainWrapper;
